export type EntryStage = "reading" | "video" | "infographic" | "mastery" | "decision" | "questions";

const FALLBACK_ORDER: EntryStage[] = ["video", "infographic", "mastery", "decision", "questions"];

/**
 * Pure lesson-entry resolver. Priority:
 *   valid saved resume stage > engine modality (if available) >
 *   Video > Visual > Insight > Decide > Questions.
 * Case studies keep their authored order (reading first).
 * Callers must only invoke this once media availability has settled.
 */
export function resolveInitialLessonStage(input: {
  availableStages: readonly string[];
  savedStage?: string | null;
  engineModality?: string | null;
  isCaseStudy?: boolean;
}): EntryStage {
  const avail = input.availableStages as readonly EntryStage[];
  if (input.savedStage && avail.includes(input.savedStage as EntryStage)) return input.savedStage as EntryStage;
  if (input.isCaseStudy) return (avail[0] ?? "questions") as EntryStage;
  if (input.engineModality && avail.includes(input.engineModality as EntryStage)) return input.engineModality as EntryStage;
  return FALLBACK_ORDER.find((s) => avail.includes(s)) ?? "questions";
}
